import { articleFigure } from './articleFigure'
import { articleMetal } from './articleMetal'
import translations from './story12.content'
import type { Article } from './types'

const t = translations
const dir = '/mine-my-phone/images/articles/story12'
const figure = articleFigure(dir)

export const story12: Article = {
  id: 12,
  slug: 'inside-the-ethical-platinum-mine-zimbabwe',
  order: 12,
  title: t.title,
  excerpt: t.excerpt,
  image: `${dir}/01.jpg`,
  imageCaption: [...t.captions[0]],
  metal: articleMetal('platinum'),
  author: 'India van Spall',
  // Country-level tag, so the pin names Unki itself — 350km from the platinum sheet's
  // northern Great Dyke entry.
  region: [
    {
      name: 'Unki Mine',
      country: 'Zimbabwe',
      coordinates: [30.0, -19.67],
      impact: 'human',
    },
  ],
  impactList: ['human', 'environmental'],
  content: {
    sections: [
      { type: 'prose', blocks: [...t.prose[0]] },
      { type: 'quote', ...t.quotes[0] },
      { type: 'prose', blocks: [...t.prose[1]] }, // How mining caused tension with the community
      figure('02.jpg', t.captions[1]),
      { type: 'prose', blocks: [...t.prose[2]] },
      { type: 'prose', blocks: [...t.prose[3]] }, // The environmental impact of platinum mining
      figure('03.jpg', t.captions[2]),
      { type: 'prose', blocks: [...t.prose[4]] }, // How IRMA bridged the gap between the mine and the community
      { type: 'quote', ...t.quotes[1] },
      { type: 'prose', blocks: [...t.prose[5]] }, // What opportunities has the Unki Mine provided for the community?
      figure('04.jpg', t.captions[3]),
      { type: 'prose', blocks: [...t.prose[6]] }, // Marking a change for the industry
    ],
  },
}
